import React from 'react';
import PropTypes from 'prop-types';

import moment, { utc } from 'moment';
// eslint-disable-next-line no-unused-vars
import fr from 'moment/locale/fr';
import { isNil } from 'lodash-es';
import { fromJS } from 'immutable';

import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';

import './ItemField.scss';

const ItemField = ({ name, value, label, type, optional, i18n, route, onClick }) => {
  const render = [];
  switch (type) {
    // STRING
    case 'string': {
      if (optional) {
        if (!(isNil(value) || value === '')) {
          render.push(
            <div className="item-field string" key={`${name}-${value}`}>
              <div className="label">{label}</div>
              <div className="value">{value}</div>
            </div>
          );
        }
      } else {
        render.push(
          <div className="item-field string" key={`${name}-${value}`}>
            <div className="label">{label}</div>
            <div className="value undefined">{value}</div>
          </div>
        );
      }
      break;
    }
    // EMAIL
    case 'email': {
      if (optional) {
        if (!(isNil(value) || value === '')) {
          render.push(
            <div className="item-field string" key={`${name}-${value}`}>
              <div className="label">{label}</div>
              <div className="value">
                <a href={`mailto:${value}`}>{value}</a>
              </div>
            </div>
          );
        }
      } else {
        render.push(
          <div className="item-field string" key={`${name}-${value}`}>
            <div className="label">{label}</div>
            <div className="value undefined">{value}</div>
          </div>
        );
      }
      break;
    }
    // DATE
    case 'date': {
      const { compactDateFormat, lang } = i18n ? i18n.toJS() : {};
      if (optional) {
        if (!(isNil(value) || value === '')) {
          moment.locale(lang || 'fr');
          const formatedDate = utc(value).format(compactDateFormat || 'D MMMM YY');
          render.push(
            <div className="item-field string" key={`${name}-${value}`}>
              {label ? <div className="label">{label}</div> : undefined}
              <div className="value">{formatedDate}</div>
            </div>
          );
        }
      } else {
        render.push(
          <div className="item-field string" key={`${name}-${value}`}>
            {label ? <div className="label">{label}</div> : undefined}
            <div className="value undefined">{value}</div>
          </div>
        );
      }
      break;
    }
    // LINK
    case 'link': {
      const link = props => <Link to={route} {...props} replace />;
      if (optional) {
        if (!isNil(value)) {
          render.push(
            <div className="item-field string" key={`${name}-${value}`}>
              <div className="label">{label}</div>
              <div className="value">
                <MuiLink
                  title={value}
                  component={React.forwardRef((props, ref) => link(props))}
                  key={`summary-link-item-${label}`}
                >
                  {value}
                </MuiLink>
              </div>
            </div>
          );
        }
      } else {
        render.push(
          <div className="item-field string" key={`${name}-${value}`}>
            <div className="label">{label}</div>
            <div className="value undefined">{value}</div>
          </div>
        );
      }
      break;
    }
    // INNER LINK
    case 'inner-link': {
      const link = props => <Link to={route} onClick={onClick} {...props} replace />;
      if (optional) {
        if (!isNil(value)) {
          render.push(
            <div className="item-field string" key={`${name}-${value}`}>
              <div className="label">{label}</div>
              <div className="value">
                <MuiLink
                  title={value}
                  component={React.forwardRef((props, ref) => link(props))}
                  key={`summary-link-item-${label}`}
                >
                  {value}
                </MuiLink>
              </div>
            </div>
          );
        }
      } else {
        render.push(
          <div className="item-field string" key={`${name}-${value}`}>
            <div className="label">{label}</div>
            <div className="value undefined">{value}</div>
          </div>
        );
      }
      break;
    }

    default: {
      render.push(
        <div className="item-field">
          <div className="label">{label}</div>
          <div className="value">{value}</div>
        </div>
      );
    }
  }
  return render;
};

ItemField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  optional: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

ItemField.defaultProps = {
  type: 'string',
  label: undefined,
  value: undefined,
  name: undefined,
  optional: false,
  i18n: fromJS({}),
  route: undefined,
  onClick: undefined,
};

export default ItemField;
